module.exports = __webpack_public_path__ + "static/media/icon-dashboard-hospital.525219c0.svg";